import React from 'react'
import styled from 'styled-components'
import { colors } from '../../../../styles/colors'

const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 5rem;

    font-family: 'SF UI Text', sans-serif;
    font-weight: 300;
    font-size: 2.5rem;
    line-height: 133%;

    color: ${colors.dark_blue};

    p {
        :nth-child( ${props => props.current_page} ){
            color: ${colors.red};
        }
        :not(:last-child) {
            margin-right: 3rem;
        }
        :hover {
            color: ${colors.red};
            cursor: pointer;
        }
    }

    @media (max-width: 767.98px) {
        line-height: 200%;
    }

`

export function Pagination ({productsPerPage, totalProducts, paginate, currentPage}) {
    const pageNumder = []
    for (let i = 1; i <= Math.ceil( totalProducts / productsPerPage ); i++ ){
        pageNumder.push(i)
    }

    function handlePaginate (pageNumber) {
        paginate(pageNumber)
        window.scrollTo(0, 0);
    }

    return (
        <PaginationContainer current_page={currentPage} className='pagination'>
            { pageNumder.map( number => <p onClick={()=> handlePaginate(number) } key={number}> {number} </p> ) }
        </PaginationContainer>
    )
}